export default "__VITE_ASSET__0e302090__"